<template>
  <el-dialog
    width="40%"
    ref="dialog"
    :visible.sync="visible"
    @closed="handleClosed"
    custom-class="el-dialog--tiny"
  >
    <div slot="title">{{ $t("c.dialog.titleChangeMasks") }}</div>

    <div>
      <p>{{ $t("c.dialog.messageChangeMasks1") }}</p>

      <v-input-tag
        v-model="localMasks"
        :placeholder="$t('c.dialog.placeholderEnterMask')"
        :validate="validateMask"
      />
    </div>

    <v-row slot="footer" justify="between">
      <v-button theme="primary" view="transparent" @click="close">
        {{
        $t("c.dialog.buttonCancel")
        }}
      </v-button>
      <v-button theme="primary" :disabled="loading || !canSaveMasks" @click="saveChanges">
        {{
        $t("c.dialog.buttonSave")
        }}
      </v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VInputTag from '@/components/common/VInputTag.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import visibleMixin from '@/mixins/visible@deprecated'
import { equalsArray } from '@/utils/common'

export default {
  name: 'VMasksDialogChange',

  components: {
    VInputTag,
    VRow
  },

  mixins: [visibleMixin],

  /**
   * TODO: можно зарефакторить
   * ----
   * 1) здесь не нужны props, т.к. компонент работает со сторой,
   * поэтому masks можно также получать из сторы внутри,
   * как и loading;
   * 2) вынести логику saveChanges в родительский компонент,
   * а в самом компоненте использовать $emit(), для обработки события снаружи
   */
  props: {
    masks: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localMasks: [...this.masks.map(tool => tool.mask)]
    }
  },

  computed: {
    canSaveMasks() {
      const masksValues = this.masks.map(tool => tool.mask)
      return !equalsArray(this.localMasks, masksValues)
    }
  },

  watch: {
    masks(values) {
      this.localMasks = [...values.map(tool => tool.mask)]
    }
  },

  methods: {
    handleClosed() {
      this.localMasks = [...this.masks.map(tool => tool.mask)]
    },

    validateMask(mask) {
      return typeof mask === 'string' && mask.length > 2
    },

    saveChanges() {
      const { localMasks, masks } = this

      const added = localMasks.reduce((result, mask) => {
        const findIndex = masks.findIndex(tool => tool.value === mask)

        if (findIndex === -1) {
          result.push(mask)
        }

        return result
      }, [])

      const removed = masks.reduce((result, mask) => {
        const { id, value } = mask

        if (!localMasks.includes(value)) {
          result.push(id)
        }

        return result
      }, [])

      this.$store
        .dispatch(types.SAVE_MASKS, {
          added,
          removed
        })
        .then(() => this.close())
    }
  }
}
</script>
